export default "__VITE_ASSET__DE12zwY___"